import * as Yup from 'yup';

import {
  FIELD_IS_NUMERIC_STRING,
  FIELD_IS_REQUIRED,
  toFieldMaximumValueErrorMessage,
  toFieldMinimumValueErrorMessage,
} from 'src/common/validation/errors';
import type { SpecificationMeasureUnit } from 'src/types/reference/SpecificationMeasureUnit';

export type SpecificationIntFloatPopupFormValuesItem = {
  value: number | null;
  measureUnit: SpecificationMeasureUnit | null;
};

export type SpecificationIntFloatPopupFormValues = {
  values: SpecificationIntFloatPopupFormValuesItem[];
};

export const specificationIntFloatPopupFormItemValidationSchema = (
  minValue: number | null,
  maxValue: number | null
): Yup.ObjectSchema<SpecificationIntFloatPopupFormValuesItem, SpecificationIntFloatPopupFormValuesItem> =>
  Yup.object<SpecificationIntFloatPopupFormValuesItem>()
    .shape({
      measureUnit: Yup.mixed<SpecificationMeasureUnit>().required(FIELD_IS_REQUIRED).default(null),

      value: Yup.number()
        .typeError(FIELD_IS_NUMERIC_STRING)
        .nullable()
        .when({
          is: () => minValue != null,
          then: (schema) =>
            schema.min(minValue as number, toFieldMinimumValueErrorMessage('Value', minValue as number)),
        })
        .when({
          is: () => maxValue != null,
          then: (schema) =>
            schema.max(maxValue as number, toFieldMaximumValueErrorMessage('Value', maxValue as number)),
        })
        .default(null),
    })
    .required(FIELD_IS_REQUIRED);

export const specificationIntFloatPopupFormValidationSchema = (minValue: number | null, maxValue: number | null) =>
  Yup.object<SpecificationIntFloatPopupFormValues>().shape({
    values: Yup.array().of(specificationIntFloatPopupFormItemValidationSchema(minValue, maxValue)),
  });
